var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33695",
    "data-name": "Group 33695",
    transform: "translate(-1 -3.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63366",
    "data-name": "Group 63366",
    transform: "translate(17276.252 6306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63363",
    "data-name": "Group 63363",
    transform: "translate(-17275.252 -6302.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63360",
    "data-name": "Group 63360"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30620",
    "data-name": "Rectangle 30620",
    width: 16,
    height: 16,
    fill: "currentColor",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221872",
    "data-name": "Path 221872",
    d: "M9.13,9.51a.664.664,0,0,0-.939.939l1.984,1.984a.642.642,0,0,0,.946-.033l4.63-5.292a.661.661,0,0,0-.992-.873L10.645,11Z",
    transform: "translate(-2.707 -2.042)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221873",
    "data-name": "Path 221873",
    d: "M14.586,7.953a.661.661,0,0,0-.661.661A5.29,5.29,0,1,1,8.632,3.323a5.815,5.815,0,0,1,1.257.146A.661.661,0,1,0,10.2,2.185,6.972,6.972,0,0,0,8.632,2a6.615,6.615,0,1,0,6.615,6.615.661.661,0,0,0-.661-.661Z",
    transform: "translate(-0.694 -0.677)",
    fill: "currentColor"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmIcon);
export default __webpack_public_path__ + "static/media/confirmIcon.db1051f9c7d02e78f72331eabcb42470.svg";
export { ForwardRef as ReactComponent };